import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TPostUpdateCanadianPayrollBusinessEntityRequest,
  TPostUpdateCanadianPayrollBusinessEntityResponse,
} from "./postUpdateCanadianPayrollBusinessEntity.schema";

export const postUpdateCanadianPayrollBusinessEntity = (
  axios: IAxiosInstance
) => {
  return async (
    body: TPostUpdateCanadianPayrollBusinessEntityRequest
  ): Promise<TPostUpdateCanadianPayrollBusinessEntityResponse> => {
    const response = await axios.noRetry.post<
      ZealApiResponse<TPostUpdateCanadianPayrollBusinessEntityResponse>
    >("/api/canadian-payroll/update-business-entity", body);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
